// src/context/AppConfigContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import useGetDefaultConfig from "../hooks/useGetDefaultConfig";
import { DEFAULT_CURRENCY } from "../constants";

const AppConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
  const { fetchConfigGet, data: configData } = useGetDefaultConfig();
  const [config, setConfig] = useState(null);
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return; // 👈 prevents re-fetch loops

    const loadConfig = async () => {
      try {
        // 1. Try localStorage first
        const cached = localStorage.getItem("pinkpeony_app_config");
        if (cached) {
          setConfig(JSON.parse(cached));
          setReady(true);
          return;
        }

        // 2. Otherwise fetch from API
        // const data = await fetchConfigGet();
        // if (data) {
        //   setConfig(data);
        //   localStorage.setItem("pinkpeony_app_config", JSON.stringify(data));
        // }
      } catch (err) {
        console.error("Failed to fetch config", err);
      } finally {
        setReady(true); // ✅ whether success or error, we're "ready"
      }
    };

    loadConfig();
  }, [ready, fetchConfigGet]);

  // Sync with hook’s latest data if it updates later
  useEffect(() => {
    if (configData) {
      setConfig(configData);
      localStorage.setItem("pageCompany_app_config", JSON.stringify(configData));
      setReady(true);
    }
  }, [configData]);

  return (
    <AppConfigContext.Provider value={{ config, ready, currency }}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => useContext(AppConfigContext);
